import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { HomePage } from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ContactPage } from './pages/ContactPage';
import { CareersPage } from './pages/CareersPage';
import { SEOPage } from './pages/services/SEOPage';
import { PPCPage } from './pages/services/PPCPage';
import { WebDesignPage } from './pages/services/WebDesignPage';
import { SocialMediaPage } from './pages/services/SocialMediaPage';
import { ContentMarketingPage } from './pages/services/ContentMarketingPage';
import { ConsultingPage } from './pages/services/ConsultingPage';
import SEOServicesPage from './pages/services/SEOServicesPage';
import TraditionalSEOPage from './pages/services/TraditionalSEOPage';
import AISEOPage from './pages/services/AISEOPage';
import PaidMarketingPage from './pages/services/PaidMarketingPage';
import GoogleAdsPage from './pages/services/GoogleAdsPage';
import MetaAdsPage from './pages/services/MetaAdsPage';
import BingAdsPage from './pages/services/BingAdsPage';
import YouTubeAdsPage from './pages/services/YouTubeAdsPage';
import ITServicesPage from './pages/services/ITServicesPage';
import WordPressPage from './pages/services/WordPressPage';
import ShopifyPage from './pages/services/ShopifyPage';
import AppDevelopmentPage from './pages/services/AppDevelopmentPage';
import WhatsAppAPIPage from './pages/services/WhatsAppAPIPage';
import FacebookMarketingPage from './pages/services/FacebookMarketingPage';
import InstagramMarketingPage from './pages/services/InstagramMarketingPage';
import LinkedInMarketingPage from './pages/services/LinkedInMarketingPage';
import TwitterMarketingPage from './pages/services/TwitterMarketingPage';
import TikTokMarketingPage from './pages/services/TikTokMarketingPage';
import PinterestMarketingPage from './pages/services/PinterestMarketingPage';
import WhatsAppMarketingPage from './pages/services/WhatsAppMarketingPage';
import YouTubeMarketingPage from './pages/services/YouTubeMarketingPage';
import ThreadsMarketingPage from './pages/services/ThreadsMarketingPage';
import CustomWebDevelopmentPage from './pages/services/CustomWebDevelopmentPage';
import QuickCommercePage from './pages/services/QuickCommercePage';
import OtherServicesPage from './pages/services/OtherServicesPage';
import LoginPage from './pages/LoginPage';
import BlogDashboard from './pages/admin/BlogDashboard';
import CareersDashboard from './pages/admin/CareersDashboard';
import BlogListPage from './pages/blog/BlogListPage';
import BlogPostPage from './pages/blog/BlogPostPage';
import WebinarLandingPage from './pages/WebinarLandingPage';
import { WhiteLabelPage } from './pages/WhiteLabelPage';
import { BusinessConsultingPage } from './pages/BusinessConsultingPage';
import { SupportPage } from './pages/SupportPage';
import { ROICalculatorPage } from './pages/ROICalculatorPage';
import { IndustryReportsPage } from './pages/IndustryReportsPage';
import DigitalMarketingGuidePage from './pages/DigitalMarketingGuidePage';
import FreeSEOAuditPage from './pages/FreeSEOAuditPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { ScrollToTop } from './components/common/ScrollToTop';
import { USLandingPage } from './pages/USLandingPage';
import { USThankYouPage } from './pages/USThankYouPage';
import { UKLandingPage } from './pages/UKLandingPage';
import { CanadaLandingPage } from './pages/CanadaLandingPage';
import { AustraliaLandingPage } from './pages/AustraliaLandingPage';
import { CountryThankYouPage } from './pages/CountryThankYouPage';

const AppContent = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin') || location.pathname === '/login';
  const isCountryLandingRoute = ['/us', '/whitelabeluk', '/whitelabelcanada', '/whitelabelaustralia'].some(p => location.pathname === p || location.pathname.startsWith(p + '/'));
  const shouldShowGlobalLayout = !isAdminRoute && !isCountryLandingRoute;

  return (
    <div className="min-h-screen flex flex-col bg-white max-w-full overflow-x-hidden">
      {shouldShowGlobalLayout && <Header />}
      <main className="flex-grow max-w-full overflow-x-hidden">
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/white-label" element={<WhiteLabelPage />} />
          <Route path="/business-consulting" element={<BusinessConsultingPage />} />
          <Route path="/roi-calculator" element={<ROICalculatorPage />} />
          <Route path="/industry-reports" element={<IndustryReportsPage />} />
          <Route path="/reports" element={<IndustryReportsPage />} />
          <Route path="/digital-marketing-guide" element={<DigitalMarketingGuidePage />} />
          <Route path="/guide" element={<DigitalMarketingGuidePage />} />
          <Route path="/free-seo-audit" element={<FreeSEOAuditPage />} />
          <Route path="/free-audit" element={<FreeSEOAuditPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          
          {/* Landing Pages */}
          <Route path="/webinar" element={<WebinarLandingPage />} />
          <Route path="/webinars" element={<WebinarLandingPage />} />
          <Route path="/us" element={<USLandingPage />} />
          <Route path="/us/thank-you" element={<USThankYouPage />} />
          <Route path="/whitelabeluk" element={<UKLandingPage />} />
          <Route path="/whitelabeluk/thank-you" element={<CountryThankYouPage country="UK" backPath="/whitelabeluk" />} />
          <Route path="/whitelabelcanada" element={<CanadaLandingPage />} />
          <Route path="/whitelabelcanada/thank-you" element={<CountryThankYouPage country="Canada" backPath="/whitelabelcanada" />} />
          <Route path="/whitelabelaustralia" element={<AustraliaLandingPage />} />
          <Route path="/whitelabelaustralia/thank-you" element={<CountryThankYouPage country="Australia" backPath="/whitelabelaustralia" />} />
          
          {/* Admin Pages */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin/blog" element={<BlogDashboard />} />
          <Route path="/admin/careers" element={<CareersDashboard />} />
          
          {/* Service Pages */}
          <Route path="/services/seo" element={<SEOPage />} />
          <Route path="/services/seo-services" element={<SEOServicesPage />} />
          <Route path="/services/traditional-seo" element={<TraditionalSEOPage />} />
          <Route path="/services/ai-seo" element={<AISEOPage />} />
          <Route path="/services/ppc" element={<PPCPage />} />
          <Route path="/services/paid-marketing" element={<PaidMarketingPage />} />
          <Route path="/services/google-ads" element={<GoogleAdsPage />} />
          <Route path="/services/meta-ads" element={<MetaAdsPage />} />
          <Route path="/services/bing-ads" element={<BingAdsPage />} />
          <Route path="/services/youtube-ads" element={<YouTubeAdsPage />} />
          <Route path="/services/web-design" element={<WebDesignPage />} />
          <Route path="/services/it-services" element={<ITServicesPage />} />
          <Route path="/services/custom-web-development" element={<CustomWebDevelopmentPage />} />
          <Route path="/services/wordpress" element={<WordPressPage />} />
          <Route path="/services/shopify" element={<ShopifyPage />} />
          <Route path="/services/app-development" element={<AppDevelopmentPage />} />
          <Route path="/services/whatsapp-api" element={<WhatsAppAPIPage />} />
          <Route path="/services/social-media" element={<SocialMediaPage />} />
          <Route path="/services/facebook-marketing" element={<FacebookMarketingPage />} />
          <Route path="/services/instagram-marketing" element={<InstagramMarketingPage />} />
          <Route path="/services/linkedin-marketing" element={<LinkedInMarketingPage />} />
          <Route path="/services/twitter-marketing" element={<TwitterMarketingPage />} />
          <Route path="/services/pinterest-marketing" element={<PinterestMarketingPage />} />
          <Route path="/services/whatsapp-marketing" element={<WhatsAppMarketingPage />} />
          <Route path="/services/tiktok-marketing" element={<TikTokMarketingPage />} />
          <Route path="/services/threads-marketing" element={<ThreadsMarketingPage />} />
          <Route path="/services/youtube-marketing" element={<YouTubeMarketingPage />} />
          <Route path="/services/content-marketing" element={<ContentMarketingPage />} />
          <Route path="/services/consulting" element={<ConsultingPage />} />
          <Route path="/services/other-services" element={<OtherServicesPage />} />
          <Route path="/services/digital-marketing-course" element={<OtherServicesPage />} />
          <Route path="/services/digital-marketing-consulting" element={<OtherServicesPage />} />
          <Route path="/services/digital-marketing-guide" element={<DigitalMarketingGuidePage />} />
          <Route path="/services/business-consulting" element={<BusinessConsultingPage />} />
          <Route path="/services/affiliate-program" element={<OtherServicesPage />} />
          <Route path="/services/white-label" element={<WhiteLabelPage />} />
          <Route path="/services/white-label-digital-marketing" element={<WhiteLabelPage />} />
          <Route path="/services/ecommerce-registration" element={<OtherServicesPage />} />
          <Route path="/services/quick-commerce" element={<QuickCommercePage />} />
          <Route path="/services/quick-commerce-registration" element={<QuickCommercePage />} />
          <Route path="/services/ai-consulting" element={<OtherServicesPage />} />
          
          {/* 404 Page */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      {shouldShowGlobalLayout && <Footer />}
      <ScrollToTop />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;